<app-select-searching-input  [noOptionText]="'-- Todos --'"
    [defaultValue]="'0'" [name]="this.name" [nameSearching]="this.nameSearching" [form]="this.form"
    [label]="('modules.schedule.financier-selector.filtro-por-financiador' | exp:'':'Filtro por financiador')" [elements]="this.financiers" [placeholderNoValue]="'Sin resultados'"
    [placeholderSearching]="('modules.schedule.financier-selector.placeholders.searching-financier' | exp:'':'Buscar financiador...')">
</app-select-searching-input>
